<template>

  <header class="flex flex-col items-center justify-center bg-cover bg-center md:bg-left-top bg-no-repeat"
    :style="{ backgroundImage: 'url(' + require(`@/assets/header.jpg`) + ')' }">
    <div class="flex flex-col items-center mt-2 md:mt-12 w-full">
      <img class="object-contain w-11/12 md:w-8/12 lg:w-4/12" src="@/assets/logo.png" />

      <div class="flex flex-col md:flex-row gap-2 md:gap-4 mt-5 w-full px-4 text-center md:w-auto">
        <router-link to="/"
          class="px-5 py-2 border border-[#f19d3b] bg-[#f19d3b] text-white font-semibold hover:bg-white hover:text-[#f19d3b] rounded-md">
          <i class="pi pi-user mr-2"></i>{{ $t('boton.soy.invitado') }}
        </router-link>
        <router-link to="/colegios"
          class="px-5 py-2 border border-[#f19d3b] bg-[#f19d3b] text-white font-semibold hover:bg-white hover:text-[#f19d3b] rounded-md">
          <i class="pi pi-globe mr-2"></i>{{ $t('boton.soy.colegio') }}
        </router-link>
        <router-link to="/prensa"
          class="px-5 py-2 border border-[#f19d3b] bg-[#f19d3b] text-white font-semibold hover:bg-white hover:text-[#f19d3b] rounded-md">
          <i class="pi pi-credit-card mr-2"></i>{{ $t('boton.soy.prensa') }}
        </router-link>
        <router-link to="/credenciales"
          class="px-5 py-2 border border-[#f19d3b] bg-[#f19d3b] text-white font-semibold hover:bg-white hover:text-[#f19d3b] rounded-md">
          <i class="pi pi-qrcode mr-2"></i>{{ $t('boton.ya.acreditado') }}
        </router-link>


      </div>

      <div class="flex items-center gap-4 my-8">
        <button @click="changeLanguage('es')" class="hover:opacity-70 transition">
          <img src="@/assets/ar.svg" class="h-8" />
        </button>
        <button @click="changeLanguage('en')" class="hover:opacity-70 transition">
          <img src="@/assets/us.svg" class="h-8" />
        </button>
      </div>

    </div>
  </header>

  <div class="w-full h-1 bg-[#00007b]"></div>

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import VueScrollTo from 'vue-scrollto';

import idiomaService from '@/services/idioma.services';

export default defineComponent({
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
    changeLanguage(lang: string) {
      this.$i18n.locale = lang;
      idiomaService.updateIdioma(lang);
    }

  },
});

</script>